import { exportPrescriptionPDF } from "../../../../util/pdfExportUtil";
import { getPrescriptionHTML } from "../../Prescriptions/Templates/PrescriptionTemplates";

/**
 * Exports the IPD Prescription to a PDF (A4/A5) using central utility
 */
// ✅ Export IPD Prescription PDF
export const exportIPDPrescription = (patientData, medicines, authCtx) => {
    // patientData here is mappedPatient from IPDPatientDischarge.js
    // It has vitals inside patientData.vitals

    exportPrescriptionPDF({
        patientData: {
            ...patientData,
            patientId: {
                firstName: patientData.name || "",
                lastName: "",
                gender: patientData.gender,
                age: patientData.age,
                mobile: patientData.phone || patientData.mobile,
                patientId: patientData.ipdAdmissionId
            },
            checkUpId: patientData.checkUpId || patientData.ipdAdmissionId || patientData.id || "-"
        },
        medicines: medicines,
        checkedData: {
            diagnosis: patientData.diagnosis || "-",
            weight: patientData.vitals?.weight || "-",
            bps: (patientData.vitals?.bp && patientData.vitals.bp.includes("/")) ? patientData.vitals.bp.split("/")[0] : patientData.vitals?.bps || "-",
            bpd: (patientData.vitals?.bp && patientData.vitals.bp.includes("/")) ? patientData.vitals.bp.split("/")[1] : patientData.vitals?.bpd || "-",
            temp: patientData.vitals?.temp || "-",
            pulse: patientData.vitals?.pulse || "-",
            spo2: patientData.vitals?.spo2 || "-",
            complaint: patientData.complaint || "-",
            advice: patientData.advice || "-"
        },
        authCtx: authCtx,
        reportTitle: "IPD PRESCRIPTION"
    });
};

// ✅ Print IPD Prescription (Open Print Window)
export const printIPDPrescription = (patientData, medicines, authCtx) => {
    const hospitalData = authCtx?.hospitalData || {};
    const { selectPrescription } = hospitalData;
    const selectedTemplate = selectPrescription || "1";

    // Map IPD data to the structure expected by the template
    const templateData = {
        patientData: {
            ...patientData,
            patientId: {
                firstName: patientData.name,
                gender: patientData.gender,
                age: patientData.age,
                mobile: patientData.mobile || patientData.phone,
                patientId: patientData.ipdAdmissionId
            },
            checkUpId: patientData.checkUpId || patientData.ipdAdmissionId || patientData.id || "-", // ✅ Corrected this to use ipdAdmissionId
            doctor: patientData.doctor
        },
        hospitaData: {
            doctorId: {
                firstName: patientData.doctor || ""
            }
        },
        medicines: medicines,
        checkedData: {
            diagnosis: patientData.diagnosis,
            billingDate: new Date().toISOString(),
            weight: patientData.weight || "-",
            bps: patientData.bps || "-",
            bpd: patientData.bpd || "-"
        },
        selectedDateTime: new Date()
    };

    const htmlContent = getPrescriptionHTML(selectedTemplate, {
        ...templateData,
        isIPD: true,
        hospitalData: hospitalData
    });

    const printWindow = window.open("", "_blank", "width=900,height=800");
    if (!printWindow) return;

    printWindow.document.write(htmlContent);
    printWindow.document.close();

    printWindow.onload = function () {
        printWindow.focus();
        printWindow.print();
        setTimeout(function () { printWindow.close(); }, 500);
    }
};
